<div class="environment-container" *ngIf="!isProduction()">
    <div class="environment">
        <span class="digit">{{ environmentLabel }}</span>
    </div>
</div>